"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReactOverlay = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: "reactOverlay" */
  "@micado-digital/react-overlay/ReactOverlay");
});
var UISkeleton = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: "skeleton" */
  "@material-ui/lab/Skeleton");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$commo, _theme$transitions, _theme$transitions$ea, _theme$palette3, _theme$palette3$succe, _theme$palette4, _theme$palette4$text, _theme$palette5, _theme$palette5$text;

  return {
    "@keyframes blink": {
      "0%": {
        opacity: 0
      },
      "50%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    imageWrapper: {
      cursor: "pointer",
      overflow: "hidden",
      position: "relative",
      zIndex: 1
    },
    link: {
      display: "block",
      "&:hover": {
        "& img": {
          transform: "scale(1.1)"
        },
        "& p": {
          color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main
        }
      }
    },
    image: {
      display: "block",
      aspectRatio: "16 / 9",
      height: "100%",
      objectFit: "cover",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.complex
      }),
      width: "100%"
    },
    state: {
      background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$commo = _theme$palette2.common) === null || _theme$palette2$commo === void 0 ? void 0 : _theme$palette2$commo.white,
      left: theme.spacing(1),
      position: "absolute",
      top: theme.spacing(1),
      "& span": {
        fontSize: 12,
        letterSpacing: 0.4,
        textTransform: "uppercase",
        "&::before": {
          animation: "$blink 1500ms ".concat((_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 ? void 0 : (_theme$transitions$ea = _theme$transitions.easing) === null || _theme$transitions$ea === void 0 ? void 0 : _theme$transitions$ea.easeInOut, " infinite"),
          background: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$succe = _theme$palette3.success) === null || _theme$palette3$succe === void 0 ? void 0 : _theme$palette3$succe.main,
          borderRadius: "50%",
          content: "''",
          display: "inline-block",
          height: 8,
          marginRight: theme.spacing(1.25),
          width: 8
        }
      }
    },
    title: {
      color: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$text = _theme$palette4.text) === null || _theme$palette4$text === void 0 ? void 0 : _theme$palette4$text.primary,
      marginTop: theme.spacing(1.25),
      transition: theme.transitions.create("color", {
        duration: theme.transitions.duration.complex
      })
    },
    location: {
      color: (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$text = _theme$palette5.text) === null || _theme$palette5$text === void 0 ? void 0 : _theme$palette5$text.primary,
      marginTop: theme.spacing(0.25),
      transition: theme.transitions.create("color", {
        duration: theme.transitions.duration.complex
      })
    }
  };
});

var Webcam = function Webcam(_ref) {
  var image = _ref.image,
      link = _ref.link,
      live = _ref.live,
      location = _ref.location,
      overlaySize = _ref.overlaySize,
      showLocation = _ref.showLocation,
      skeleton = _ref.skeleton,
      title = _ref.title;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showWebcam = _useState2[0],
      setShowWebcam = _useState2[1];

  var css = useStyles();

  if (skeleton) {
    return /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(UISkeleton, {
      className: css.image,
      width: "100%",
      variant: "text",
      animation: "wave"
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: css.title,
      component: "p"
    }, /*#__PURE__*/_react.default.createElement(UISkeleton, {
      width: "100%",
      variant: "text",
      animation: "wave"
    })), showLocation && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: css.location,
      component: "p",
      variant: "caption"
    }, /*#__PURE__*/_react.default.createElement(UISkeleton, {
      width: "100%",
      variant: "text",
      animation: "wave"
    })));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: css.imageWrapper,
    onClick: function onClick() {
      return link && setShowWebcam(true);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: css.image,
    src: image,
    alt: title,
    height: "350",
    width: "620",
    loading: "lazy"
  }), live && /*#__PURE__*/_react.default.createElement(_Chip.default, {
    className: css.state,
    size: "small",
    label: "Live"
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.title,
    component: "p"
  }, title), showLocation && location && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.location,
    component: "p",
    variant: "caption"
  }, location)), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, showWebcam && /*#__PURE__*/_react.default.createElement(ReactOverlay, {
    aspectRatio: "16:9",
    iframeURL: link,
    mode: "iframe",
    setOpen: setShowWebcam,
    size: overlaySize,
    toolbarColor: "secondary"
  })));
};

var _default = Webcam;
exports.default = _default;